function updateCart(gift_id, product_id){
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    data: "quantity=1&id=" + gift_id,
    dataType: "json",	
    async: true, 
    success: function() {
      console.log('success')
      location.reload();
    },
    error: function(i) {
      console.log('error')
    }
  })
};

$( document ).ready(function() {

  $(".quantity__addition_button").on("click",function(e) {
    var gift_id = $(this).attr('data-gift-id');
    var max_spend = $(this).attr('data-max-spend') != undefined ? $(this).attr('data-max-spend') : 0;
    var handle_type = $(this).attr('data-handle-type');
    var in_cart = false;

    $.ajax({
        type: "post",
        url: "/cart.js",
        dataType: "json",	
        async: true, 
        success: function(data) {
          
          if(max_spend > 0){
            $( "button .quantity__addition_button" ).each(function( index ) {
              if($(this).attr('data-gift-id') != undefined){
                gift_id = $(this).attr('data-gift-id');
              }
            });
          }
          
          $.each(data.items, function( index, item ) {
            if(item.id == gift_id){
              in_cart = true;
            }
          });
          
          if(in_cart == false && (data.total_price/100) > max_spend && gift_id != undefined){
            updateCart(gift_id);
          }
        },
        error: function(i) {
          console.log('error')
        }
    })
  });  
  
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  // Don't add keyup handler for header-drawer main toggle, it's handled by the custom element
  if (summary.closest('header-drawer') && summary.closest('[id="Details-menu-drawer-container"]')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    // Привязываем обработчик только к кнопкам закрытия меню, а не ко всем кнопкам
    this.querySelectorAll('.menu-drawer__close-button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    // Добавляем обработчик для кнопок закрытия mobile-facets
    this.querySelectorAll('.mobile-facets__close-button').forEach(button => button.addEventListener('click', this.onMobileFacetsCloseButtonClick.bind(this)));
    
    // Предотвращаем закрытие меню при клике на кнопки языкового селектора
    this.querySelectorAll('.lang-select .btn-select').forEach(button => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });
    
    // Обработка кнопки закрытия в header menu-drawer для удаления overflow-hidden-tablet
    const headerCloseButton = this.querySelector('.menu-drawer__header .menu-drawer__close-button');
    if (headerCloseButton) {
      headerCloseButton.addEventListener('click', this.onHeaderCloseButtonClick.bind(this));
    }
    
    // Добавляем обработчик клика вне области menu-drawer для закрытия меню
    this.onOutsideClickHandler = this.onOutsideClick.bind(this);
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    const detailsElement = this.mainDetailsToggle || this.querySelector('details') || this.querySelector('#Details-menu-drawer-container');
    openDetailsElement === detailsElement ? this.closeMenuDrawer(event, detailsElement ? detailsElement.querySelector('summary') : null) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    const mainDetailsToggle = this.mainDetailsToggle || this.querySelector('details') || this.querySelector('#Details-menu-drawer-container');
    
    if (detailsElement === mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    // Попробуем разные способы найти details элемент
    let detailsElement = this.mainDetailsToggle;
    if (!detailsElement) {
      detailsElement = this.querySelector('details');
    }
    if (!detailsElement) {
      detailsElement = this.querySelector('#Details-menu-drawer-container');
    }
    if (!detailsElement) {
      detailsElement = document.querySelector('#Details-menu-drawer-container');
    }
    
    const menuDrawerContainer = this.querySelector('.menu-drawer-container') || this.querySelector('details');
    
    if (!detailsElement) {
      console.error('MenuDrawer: Could not find details element at all!');
      return;
    }
    
    setTimeout(() => {
      if (detailsElement && detailsElement.classList) {
        detailsElement.classList.add('menu-opening');
      }
      if (menuDrawerContainer && menuDrawerContainer.classList) {
        menuDrawerContainer.classList.add('menu-opening');
      }
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(detailsElement, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    
    // Hide help button when menu is open
    const helpButton = document.querySelector('.embeddedServiceHelpButton');
    if (helpButton) helpButton.style.display = 'none';
    const cmpboxrecall = document.querySelector('.cmpboxrecall');
    if (cmpboxrecall) cmpboxrecall.style.display = 'none';
    const loyaltyLionBeacon = document.querySelector('#loyaltylion-beacon-frame');
    if (loyaltyLionBeacon) loyaltyLionBeacon.style.display = 'none';

    const octane = document.querySelector('#octane-shopping-assistant-root');
    if (octane) octane.style.display = 'none';  

    if(typeof window.acsb !== 'undefined' && window.acsb.initialized) {
      const acui = document.querySelectorAll('access-widget-ui');
      if(acui.length > 3) {
        acui[3].shadowRoot.querySelector('button').style.display = 'none';
      }
    }
    document.body.classList.add('menu-opened');
    
    // Добавляем обработчик клика вне области с небольшой задержкой
    setTimeout(() => {
      document.addEventListener('click', this.onOutsideClickHandler);
    }, 100);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      const menuDrawerContainer = this.querySelector('.menu-drawer-container');
      const detailsElement = this.mainDetailsToggle || this.querySelector('details') || this.querySelector('#Details-menu-drawer-container');
      
      if (detailsElement) {
        detailsElement.classList.remove('menu-opening');
      }
      if (menuDrawerContainer) {
        menuDrawerContainer.classList.remove('menu-opening');
      }
      
      if (detailsElement) {
        detailsElement.querySelectorAll('details').forEach(details =>  {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
      }
      
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      // Также удаляем overflow-hidden-tablet при закрытии menu-drawer
      document.body.classList.remove('overflow-hidden-tablet');
      removeTrapFocus(elementToFocus);
      
      // Show help button when menu is closed
      const helpButton = document.querySelector('.embeddedServiceHelpButton');
      if (helpButton) helpButton.style.display = '';
      const cmpboxrecall = document.querySelector('.cmpboxrecall');
      if (cmpboxrecall) cmpboxrecall.style.display = '';
      const loyaltyLionBeacon = document.querySelector('#loyaltylion-beacon-frame');
      if (loyaltyLionBeacon) loyaltyLionBeacon.style.display = '';
      const octane = document.querySelector('#octane-shopping-assistant-root');
      if (octane) octane.style.display = ''; 
      
      if(typeof window.acsb !== 'undefined' && window.acsb.initialized) {
        const acui = document.querySelectorAll('access-widget-ui');
        if(acui.length > 3) {
          acui[3].shadowRoot.querySelector('button').style.display = '';
        }
      }

      document.body.classList.remove('menu-opened');

      // Удаляем обработчик клика вне области
      document.removeEventListener('click', this.onOutsideClickHandler);
      
      if (detailsElement) {
        this.closeAnimation(detailsElement);
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      const detailsElement = this.mainDetailsToggle || this.querySelector('details') || this.querySelector('#Details-menu-drawer-container');
      if (detailsElement && detailsElement.hasAttribute('open') && !detailsElement.contains(document.activeElement)) {
        this.closeMenuDrawer();
      }
    });
  }

  onHeaderCloseButtonClick(event) {
    // Удаляем класс overflow-hidden-tablet при клике на кнопку закрытия в header
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('menu-opened');
    
    // Вызываем стандартную обработку закрытия
    this.onCloseButtonClick(event);
  }

  onOutsideClick(event) {
    const detailsElement = this.mainDetailsToggle || this.querySelector('details') || this.querySelector('#Details-menu-drawer-container');
    
    // Проверяем, что меню открыто
    if (!detailsElement || !detailsElement.hasAttribute('open')) {
      return;
    }
    
    // Проверяем, что клик был вне области menu-drawer
    const menuDrawer = this.querySelector('#menu-drawer') || this.querySelector('.menu-drawer');
    const menuDrawerContainer = this.querySelector('.menu-drawer-container') || detailsElement;
    const summaryElement = detailsElement.querySelector('summary');
    
    // Если клик был по кнопке открытия меню или внутри menu-drawer контейнера, не закрываем
    if (event.target === summaryElement || 
        summaryElement.contains(event.target) || 
        (menuDrawer && menuDrawer.contains(event.target)) ||
        (menuDrawerContainer && menuDrawerContainer.contains(event.target))) {
      return;
    }
    
    console.log('Closing menu drawer from outside click'); // Добавляем отладку
    
    // Закрываем меню
    this.closeMenuDrawer(event, summaryElement);
  }

  onCloseButtonClick(event) {
    // Проверяем, что это действительно кнопка закрытия меню
    if (!event.currentTarget.classList.contains('menu-drawer__close-button')) {
      return;
    }
    
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  onMobileFacetsCloseButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    // Находим родительский details элемент для mobile-facets__submenu
    const detailsElement = event.currentTarget.closest('details');
    if (detailsElement) {
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
    
    // Show help button when menu is closed
    const helpButton = document.querySelector('.embeddedServiceHelpButton');
    if (helpButton) helpButton.style.display = '';
    const cmpboxrecall = document.querySelector('.cmpboxrecall');
    if (cmpboxrecall) cmpboxrecall.style.display = '';
    const loyaltyLionBeacon = document.querySelector('#loyaltylion-beacon-frame');
    if (loyaltyLionBeacon) loyaltyLionBeacon.style.display = '';

    if(typeof window.acsb !== 'undefined' && window.acsb.initialized) {
      const acui = document.querySelectorAll('access-widget-ui');
      if(acui.length > 3) {
        acui[3].shadowRoot.querySelector('button').style.display = '';
      }
    }

    document.body.classList.remove('menu-opened');
    
    // Remove overflow class
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('overflow-hidden-tablet');
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || 0; // Убираем проверку header-wrapper
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    // Попробуем разные способы найти details элемент
    let detailsElement = this.mainDetailsToggle;
    if (!detailsElement) {
      detailsElement = this.querySelector('details');
    }
    if (!detailsElement) {
      detailsElement = this.querySelector('#Details-menu-drawer-container');
    }
    if (!detailsElement) {
      detailsElement = document.querySelector('#Details-menu-drawer-container');
    }
    
    const menuDrawerContainer = this.querySelector('.menu-drawer-container') || this.querySelector('details');
    
    if (!detailsElement) {
      console.error('HeaderDrawer: Could not find details element at all!');
      return;
    }
    
    setTimeout(() => {
      if (detailsElement && detailsElement.classList) {
        detailsElement.classList.add('menu-opening');
      }
      if (menuDrawerContainer && menuDrawerContainer.classList) {
        menuDrawerContainer.classList.add('menu-opening');
      }
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(detailsElement, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    
    // Hide help button when menu is open
    const helpButton = document.querySelector('.embeddedServiceHelpButton');
    if (helpButton) helpButton.style.display = 'none';
    const cmpboxrecall = document.querySelector('.cmpboxrecall');
    if (cmpboxrecall) cmpboxrecall.style.display = 'none';
    const loyaltyLionBeacon = document.querySelector('#loyaltylion-beacon-frame');
    if (loyaltyLionBeacon) loyaltyLionBeacon.style.display = 'none';
    
    if(typeof window.acsb !== 'undefined' && window.acsb.initialized) {
      const acui = document.querySelectorAll('access-widget-ui');
      if(acui.length > 3) {
        acui[3].shadowRoot.querySelector('button').style.display = 'none';
      }
    }
    document.body.classList.add('menu-opened');

    // Добавляем обработчик клика вне области с небольшой задержкой
    setTimeout(() => {
      document.addEventListener('click', this.onOutsideClickHandler);
    }, 100);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('menu-opened');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    if(this.prevButton != null){
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      if(this.prevButton != null){
        this.prevButton.setAttribute('disabled', 'disabled');
      }
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);


function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}


 /*function addToCart(productId,quantity) {
  var cartNotification = document.querySelector('cart-notification');
   var datatoSend = {items: [
    {
     id: productId,
     quantity: quantity
    }
  ]}
  console.log(${routes.cart_add_url}");
   var config = { headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },

  method: "POST",
  body: JSON.stringify(datatoSend)
}

  fetch(`${routes.cart_add_url}`,config)
  .then(response => response.json())
  .then(response => {
      cartNotification.renderContents(response);
   
  } );
  

 }*/

//  function addToCart(productId,quantity){
//   var quantity = $(".quantity option:selected").val();
//   quantity = parseInt(quantity);
//   var id = productId;
//   $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       dataType: 'json',
//       data: {id:id,quantity:quantity},
//       success: function(){
//           location.href="/cart";
//       }
//   });
//  }


/*(function() {
  var touchingCarousel = false
    , touchStartCoords

  document.body.addEventListener('touchstart', function(e) {
    if (e.target.closest('.carousel-cell, .tns-item')) {
      touchingCarousel = true
    } else {
      touchingCarousel = false
      return
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  })

  document.body.addEventListener('touchmove', function(e) {
    if (!(touchingCarousel && e.cancelable)) return

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    }

    // Use a fixed threshold instead of Flickity.defaults.dragThreshold
    if (Math.abs(moveVector.x) > 10)
      e.preventDefault()

  }, {passive: false})

  // Polyfill for Element.closest
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest =
      function(s) {
        var el = this

        do {
          if (el.matches(s)) return el
          el = el.parentElement || el.parentNode
        } while (el !== null && el.nodeType === 1)
        return null
      }
  }
})();*/

// Глобальный обработчик для закрытия menu-drawer при клике вне области
document.addEventListener('DOMContentLoaded', function() {
  let isMenuDrawerOpen = false;
  let currentMenuDrawer = null;
  
  // Отслеживаем открытие menu-drawer
  document.addEventListener('click', function(event) {
    const summary = event.target.closest('header-drawer summary, menu-drawer summary');
    if (summary) {
      const details = summary.closest('details');
      if (details && details.id === 'Details-menu-drawer-container') {
        setTimeout(() => {
          if (details.hasAttribute('open')) {
            isMenuDrawerOpen = true;
            currentMenuDrawer = details;
            console.log('Menu drawer opened globally'); // Отладка
          } else {
            isMenuDrawerOpen = false;
            currentMenuDrawer = null;
            console.log('Menu drawer closed globally'); // Отладка
          }
        }, 10);
      }
    }
  });
  
  // Глобальный обработчик клика для закрытия menu-drawer
  document.addEventListener('click', function(event) {
    if (!isMenuDrawerOpen || !currentMenuDrawer) return;
    
    // Проверяем, что клик был вне menu-drawer
    const menuDrawer = document.querySelector('#menu-drawer');
    const summary = currentMenuDrawer.querySelector('summary');
    
    if (event.target === summary || 
        summary.contains(event.target) || 
        (menuDrawer && menuDrawer.contains(event.target))) {
      return;
    }
    
    console.log('Closing menu drawer globally'); // Отладка
    
    // Закрываем menu-drawer
    currentMenuDrawer.removeAttribute('open');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
    
    // Убираем overflow класс
    document.body.classList.remove('overflow-hidden-tablet');
    
    isMenuDrawerOpen = false;
    currentMenuDrawer = null;
  });
});